import '@rainbow-me/rainbowkit/styles.css';
import {
  getDefaultConfig,
  RainbowKitProvider,
  darkTheme,
  lightTheme,
} from '@rainbow-me/rainbowkit';
import { WagmiProvider } from 'wagmi';
import {
  mainnet,
} from 'wagmi/chains';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { defineChain, http } from 'viem';


const projectId = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID;
const MAINNET_RPC_URL = import.meta.env.VITE_ALCHEMY_MAINNET_RPC_URL;

if (!projectId) {
  console.warn(
    'WalletConnect Project ID missing'
  );

}

// ========================================
// WAGMI CONFIG
// ========================================

const config = getDefaultConfig({
  appName: 'Palzea',
  projectId,
  chains: [
    mainnet,
  ],
  ssr: false,
  reconnectOnMount: false,
  pollingInterval: 0,
  transports: {

    // Ethereum
    [mainnet.id]: http(MAINNET_RPC_URL),

  },
});

// ========================================
// QUERY CLIENT
// ========================================

const queryClient =
  new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchInterval: false,
        retry: 1,
        staleTime: 1000 * 60 * 5,
      },
    },
  });


// ================================
// Web3 Provider Component
// ================================
export const Web3Provider = ({ children, isDark = true }) => {
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider
          modalSize="compact"
          theme={
            isDark
              ? darkTheme({
                accentColor: 'hsl(45, 93%, 47%)',
                accentColorForeground: 'black',
                borderRadius: 'medium',
                overlayBlur: 'small',
              })
              : lightTheme({
                accentColor: 'hsl(45, 93%, 47%)',
                accentColorForeground: 'black',
                borderRadius: 'medium',
                overlayBlur: 'small',
              })
          }
        >
          {children}
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
};

export default Web3Provider;